import type { ImageParams } from 'components/Common/ResponsiveImage'
import ResponsiveImage from 'components/Common/ResponsiveImage'
import ModalContext from 'contexts/ModalContext'
import TextButton from 'LuxKit/Button/TextButton'
import ImageGalleryLightbox from 'LuxKit/Carousel/ImageGalleryLightbox'
import LineImagesIcon from 'LuxKit/Icons/line/LineImagesIcon'
import { useCallback, useContext } from 'react'
import * as React from 'react'
import { useIntl } from 'react-intl'
import { GridContainer, GalleryButtons, GridImageClickable } from '../TripPlanDetailDrawer.styles'

const DEFAULT_IMAGE_PARAMS: ImageParams = { tabletWidth: '400px', quality: 'good' }
const MAIN_IMAGE_PARAMS: ImageParams = { tabletWidth: '800px', quality: 'best' }
const GRID_IMAGE_COUNT = 3

interface Props {
  images: Array<App.Image>
}

function OfferDetailImageGallery({ images }: Props) {
  const intl = useIntl()
  const showModal = useContext(ModalContext)

  const gridImages = images.slice(0, GRID_IMAGE_COUNT)
  const hasSingleImage = gridImages.length === 1

  const handleGalleryImageClick = useCallback((e: React.MouseEvent<HTMLButtonElement>) => {
    const index = Number(e.currentTarget.dataset.index) || 0
    showModal(
      <ImageGalleryLightbox images={images} defaultIndex={index} />,
    )
  }, [images, showModal])

  const openGalleryLightbox = useCallback(() => {
    showModal(
      <ImageGalleryLightbox images={images} />,
    )
  }, [images, showModal])

  return (
    <GridContainer $singleImage={hasSingleImage}>
      {gridImages.map((image, imageIndex) => image.id && (
        <GridImageClickable
          key={image.id}
          onClick={handleGalleryImageClick}
          data-index={imageIndex}
        >
          <ResponsiveImage
            id={image.id}
            fit="center"
            {...(imageIndex === 0 ? MAIN_IMAGE_PARAMS : DEFAULT_IMAGE_PARAMS)}
          />
        </GridImageClickable>
      ))}
      {images.length > 1 && (
        <GalleryButtons direction="horizontal" gap={8} horizontalAlign="end">
          <TextButton
            kind="secondary"
            variant="dark"
            startIcon={<LineImagesIcon />}
            onClick={openGalleryLightbox}
          >
            {intl.formatMessage({
              id: 'bR2MjHBxeWo_o5ut-H9M',
              defaultMessage: 'View gallery',
              description: 'Button to open hotel image gallery lightbox in the gallery view',
            })}
          </TextButton>
        </GalleryButtons>
      )}
    </GridContainer>
  )
}

export default OfferDetailImageGallery
